import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "concierge__checkbox_checked",
  "use": "concierge__checkbox_checked-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"concierge__checkbox_checked\">\n  <rect fill=\"var(--color-primary-lighter, #374f67)\" width=\"14\" height=\"14\" rx=\"2\" />\n  <path fill=\"none\" stroke=\"var(--color-icons-alt, #fff)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.8981 6.7517L6.7811 8.5l3.2313-3\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol